module.exports = __webpack_public_path__ + "static/img/rtgs-payments.5b23cb7f.svg";